import { render, staticRenderFns } from "./InsightCreate.vue?vue&type=template&id=114a6c25&scoped=true"
import script from "./InsightCreate.vue?vue&type=script&lang=js"
export * from "./InsightCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114a6c25",
  null
  
)

export default component.exports